import { createContext, useContext } from 'react';
import { InfiniteScrollTableState } from '../state';
import { FiltersMap } from '@wix/bex-core';
import { assertContextValue } from '../createContext';

export const InfiniteScrollTableContext =
  createContext<InfiniteScrollTableState<any, any> | null>(null);

export const InfiniteScrollTableProvider = InfiniteScrollTableContext.Provider;
export const InfiniteScrollTableConsumer = InfiniteScrollTableContext.Consumer;

export const useInfiniteScrollTableContext = <T, F extends FiltersMap>() => {
  const value = useContext(InfiniteScrollTableContext);
  assertContextValue('InfiniteScrollTableProvider', value);
  return value as InfiniteScrollTableState<T, F>;
};
